import React from 'react';
import { 
  Code, Coffee, Pilcrow, Database, FileSpreadsheet, Monitor, BookOpen,
  Layers, Brain, Smartphone, Palette, Cloud, Bug, Settings, BarChart3,
  Users, Zap, Globe, Server, TestTube, GitBranch, Cpu, Target,
  Bot, MessageSquare, TrendingUp, Network, Eye
} from 'lucide-react';

export const offlineClasses = [
    {
        id: 'oc17',
        slug: 'c-cpp-complete-offline',
        title: 'C & C++ Complete Programming Course',
        category: 'offline',
        level: 'Beginner to Intermediate',
        duration: '3 Months',
        location: 'indore',
        lectures: '45+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "20+",
        assignments: "20+",
        price: '7500',
        originalPrice: '7500',
        startDate: '2025-09-04',
        banner: {
            title: 'C & C++',
            subtitle: 'Complete Programming',
            background: 'bg-gradient-to-r from-blue-600 to-purple-600',
            Icon: Code
        },
        description: 'Master both C and C++ programming languages in this comprehensive course. Start with C fundamentals and progress to advanced C++ with Object-Oriented Programming concepts. Perfect for beginners who want to build a strong foundation in systems programming and modern C++ development.',
        overview: 'This comprehensive course combines C programming fundamentals with advanced C++ Object-Oriented Programming. You will learn C basics, memory management, and system programming, then progress to C++ features, OOP principles, and modern C++ development practices. Ideal for students seeking a complete foundation in both languages.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal',
            'Combined C & C++ Curriculum',
            'Hands-on Projects & Real-world Applications'
        ],
        whyOSOP: [
            'India\'s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        skillsCovered: 'C Programming, C++ Programming, OOP, Memory Management, System Programming',
        toolsCovered: 'Turbo C++, Visual Studio Code, GCC Compiler, Debugging Tools',
        certification: 'Training Certification on Successful Completion of the Course',
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Console and GUI applications' },
            { title: 'Support', description: '24/7 doubt resolution' },
            { title: 'Placement Assistance', description: 'Career guidance and job placement support' }
        ],
        curriculum: [
            { title: 'PART I: C Programming Fundamentals', topics: [
                'Introduction to Computer & C Programming',
                'C Basics: Variables, Data Types, Operators',
                'C Programming Structure & Error Handling',
                'Conditional Statements & Control Flow',
                'Operators: Arithmetic, Logical, Bitwise',
                'Looping Statements: for, while, do-while',
                'Jump Statements: break, continue, goto',
                'Switch Statement & Decision Making',
                'Functions in C Programming',
                'Pointers in C & Memory Management',
                'Recursion & Recursive Programming',
                'Arrays in C: 1D & 2D Arrays',
                'Strings & String Functions',
                'User-Defined Data Types: Structures, Unions',
                'File Handling & I/O Operations'
            ] },
            { title: 'PART II: C++ Programming & OOP', topics: [
                'Introduction to C++ & its Features',
                'Basic Input/Output: cout, cin, endl',
                'Namespaces & Reference Variables',
                'Function Overloading & Default Arguments',
                'std::string Class & String Operations',
                'Object-Oriented Programming Concepts',
                'Classes & Objects: Definition & Creation',
                'Access Modifiers: public, private, protected',
                'this Pointer & Scope Resolution Operator',
                'Object Passing & Returning',
                'Constructors & Destructors',
                'Inline Functions & Static Members',
                'Dynamic Memory Management',
                'Friend Functions & Friend Classes',
                'Operator Overloading',
                'Inheritance & its Types',
                'Function Overriding & Virtual Functions',
                'Abstract Classes & Polymorphism',
                'Exception Handling & Templates',
                'C++ I/O Streams & File Handling',
                'Advanced C++ Features & Best Practices'
            ] }
        ]
    },
    {
        id: 'oc16',
        slug: 'java-for-beginners-offline',
        title: 'Java Programming for Beginners',
        category: 'offline',
        level: 'Beginner',
        duration: '2 Months',
        location: 'indore',
        lectures: '25+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '6500',
        originalPrice: '6500',
        banner: {
            title: 'Java',
            subtitle: 'Programming for Beginners',
            background: 'bg-gradient-to-r from-orange-600 to-red-600',
            Icon: Coffee
        },
        description: 'Java is one of the most popular and versatile programming languages used for developing desktop applications, web applications, mobile apps, and enterprise software. This comprehensive beginner course covers Java fundamentals, object-oriented programming, and practical application development.',
        overview: 'Java is one of the most popular and versatile programming languages used for developing desktop applications, web applications, mobile apps, and enterprise software. This comprehensive beginner course covers Java fundamentals, object-oriented programming, and practical application development. Perfect for students with no prior programming experience who want to build a strong foundation in Java programming.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            "India's Most Premium Coding Class",
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        skillsCovered: 'Java Programming, OOP, Basic Algorithms, Problem Solving',
        toolsCovered: 'Eclipse IDE, IntelliJ IDEA, VS Code, JDK',
        certification: 'Training Certification on Successful Completion of the Course',
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Console and GUI applications' },
            { title: 'Support', description: '24/7 doubt resolution' }
        ],
        curriculum: [
            { title: 'Introduction to Java', topics: [
                'What is Java? History and Features',
                'Java Editions (SE, EE, ME)',
                'JDK, JRE, JVM Architecture',
                'Setting up Java Development Environment',
                'First Java Program: Hello World',
                'Java Compilation Process',
                'Applications of Java in Real World'
            ] },
            { title: 'Java Fundamentals', topics: [
                'Java Syntax and Structure',
                'Variables and Data Types (Primitive & Reference)',
                'Type Casting and Type Conversion',
                'Constants and Literals',
                'Comments: Single-line, Multi-line, Documentation',
                'Input/Output using Scanner class',
                'Basic Operators: Arithmetic, Relational, Logical'
            ] },
            { title: 'Control Flow Statements', topics: [
                'Decision Making: if, if-else, if-else-if',
                'Switch Statement and Switch Expression',
                'Loops: for, while, do-while',
                'Enhanced for loop (for-each)',
                'Nested Loops and Loop Control',
                'Break and Continue Statements',
                'Practice Problems and Mini Projects'
            ] },
            { title: 'Arrays and Strings', topics: [
                'One-Dimensional Arrays: Declaration, Initialization',
                'Array Operations: Traversal, Searching, Sorting',
                'Two-Dimensional Arrays and Matrix Operations',
                'String Class and String Methods',
                'StringBuilder and StringBuffer',
                'String Manipulation and Regular Expressions',
                'Array of Objects and String Arrays'
            ] },
            { title: 'Methods and Functions', topics: [
                'Method Declaration and Definition',
                'Parameters and Return Types',
                'Method Overloading',
                'Variable Arguments (Varargs)',
                'Static Methods and Instance Methods',
                'Recursion: Concept and Implementation',
                'Method Chaining and Best Practices'
            ] },
            { title: 'Object-Oriented Programming (OOP)', topics: [
                'Classes and Objects: Definition and Creation',
                'Constructors: Default, Parameterized, Copy',
                'Access Modifiers: public, private, protected, default',
                'this keyword and its usage',
                'Encapsulation: Data Hiding and Getters/Setters',
                'Inheritance: Single, Multilevel, Hierarchical',
                'super keyword and Method Overriding'
            ] },
            { title: 'Advanced OOP Concepts', topics: [
                'Polymorphism: Compile-time and Runtime',
                'Abstract Classes and Abstract Methods',
                'Interfaces: Definition and Implementation',
                'Multiple Interface Implementation',
                'Final Keyword: Classes, Methods, Variables',
                'Package Creation and Import Statements',
                'Access Control and Visibility'
            ] },
            { title: 'Exception Handling', topics: [
                'What are Exceptions? Types of Exceptions',
                'Checked vs Unchecked Exceptions',
                'try-catch-finally Blocks',
                'throw and throws Keywords',
                'Custom Exception Classes',
                'Exception Handling Best Practices',
                'Resource Management with try-with-resources'
            ] },
            { title: 'Collections Framework', topics: [
                'Introduction to Collections Framework',
                'List Interface: ArrayList, LinkedList',
                'Set Interface: HashSet, TreeSet',
                'Map Interface: HashMap, TreeMap',
                'Iterator and Enhanced for Loop',
                'Collections Utility Class',
                'Generics: Type Safety and Type Parameters'
            ] },
            { title: 'File Handling and I/O', topics: [
                'File Class and File Operations',
                'FileReader and FileWriter',
                'BufferedReader and BufferedWriter',
                'Serialization and Deserialization',
                'ObjectInputStream and ObjectOutputStream',
                'File Handling Best Practices',
                'Mini Project: File Management System'
            ] },
            { title: 'Java 8+ Features (Modern Java)', topics: [
                'Lambda Expressions and Functional Interfaces',
                'Stream API: map, filter, reduce, collect',
                'Method References and Constructor References',
                'Optional Class and Null Safety',
                'Default Methods in Interfaces',
                'Date and Time API (java.time package)',
                'Introduction to CompletableFuture'
            ] },
            { title: 'Projects and Applications', topics: [
                'Console-based Calculator Application',
                'Student Management System',
                'Library Management System',
                'Bank Account Management System',
                'Simple GUI Applications using Swing',
                'File Processing and Data Analysis',
                'Final Project: Complete Application Development'
            ] }
        ]
    },
    {
        id: 'oc1',
        slug: 'mern-full-stack-offline',
        title: 'Full Stack MERN Development',
        category: 'offline',
        level: 'Intermediate to Advanced',
        duration: '4-6 Months',
        location: 'indore',
        lectures: '80+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '15000',
        originalPrice: '17000',
        banner: {
            title: 'Full Stack',
            subtitle: 'MERN Development',
            background: 'bg-gradient-to-r from-cyan-500 to-blue-600',
            Icon: Layers
        },
        description: 'Offline, classroom-based MERN stack development course.',
        overview: 'Master MongoDB, Express.js, React, and Node.js through face-to-face learning in our physical classroom.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Fullstack applications' }
        ],
        curriculum: [
            { title: 'Frontend', topics: ['React.js', 'JavaScript ES6+', 'HTML/CSS'] },
            { title: 'Backend', topics: ['Node.js', 'Express.js', 'REST APIs'] },
            { title: 'Database', topics: ['MongoDB', 'Mongoose', 'Integration'] }
        ]
    },
    {
        id: 'oc2',
        slug: 'python-django-offline',
        title: 'Python & Django Web Development',
        category: 'offline',
        level: 'Beginner to Advanced',
        duration: '4 Months',
        location: 'indore',
        lectures: '80+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '12500',
        originalPrice: '15000',
        banner: {
            title: 'Python & Django',
            subtitle: 'Web Development',
            background: 'bg-gradient-to-r from-green-700 to-green-500',
            Icon: Code
        },
        description: 'Offline Python and Django web development course.',
        overview: 'Learn Python programming and Django web framework through classroom-based training.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Web applications' }
        ],
        curriculum: [
            { title: 'Python Basics', topics: ['Syntax', 'OOP', 'Data Structures'] },
            { title: 'Django Framework', topics: ['Models', 'Views', 'Templates'] },
            { title: 'Advanced Django', topics: ['REST APIs', 'Authentication', 'Deployment'] }
        ]
    },
    {
        id: 'oc3',
        slug: 'java-core-advance-offline',
        title: 'Java Core & Advanced Programming',
        category: 'offline',
        level: 'Intermediate to Advanced',
        duration: '3 Months',
        location: 'indore',
        lectures: '35+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '12500',
        originalPrice: '12500',
        banner: {
            title: 'Java Core',
            subtitle: '+ Advanced',
            background: 'bg-gradient-to-r from-red-700 to-orange-600',
            Icon: Coffee
        },
        description: 'Offline Java core and advanced programming course.',
        overview: '🧠 Java Core + Advanced – Complete Syllabus (Summarized)\nFor Developers | With Real-time Projects | Certification + Placement Ready',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate on completion' },
            { title: 'Placement Assistance', description: 'Placement support and interview prep' },
            { title: 'Projects', description: 'Mini and full-stack projects using Java' },
            { title: 'Mock Tests', description: 'Assessment & mock interviews' }
        ],
        curriculum: [
            { title: 'Introduction to Java', topics: [
                'What, Why, and History of Java',
                'Editions, Versions, JDK, JRE, JVM',
                'Installation & Environment Setup',
                'Java Compilation Process',
                'Applications & Features of Java'
            ] },
            { title: 'Java Fundamentals', topics: [
                'Basic Syntax & First Java Program',
                'Data Types (Primitive & Non-Primitive)',
                'Variables, Constants, and Type Casting',
                'Comments, ASCII, Unicode',
                'Input/Output (Scanner, System.in/out)'
            ] },
            { title: 'Operators & Expressions', topics: [
                'Arithmetic, Logical, Bitwise, Relational',
                'Assignment, Ternary, and Operator Precedence',
                'Type Conversion & Wrapper Classes'
            ] },
            { title: 'Control Flow Statements', topics: [
                'Conditional: if, if-else, switch',
                'Loops: for, while, do-while, for-each',
                'Jump Statements: break, continue'
            ] },
            { title: 'Methods and Functions', topics: [
                'Defining, Calling, Return Types',
                'Method Overloading',
                'Variable Arguments (Varargs)',
                'Static Methods & the main() method'
            ] },
            { title: 'Object-Oriented Programming (OOP)', topics: [
                'Classes & Objects',
                'Access Modifiers, this keyword',
                'Encapsulation & Constructors (Default, Param., Copy)',
                'Inheritance & super keyword',
                'Polymorphism (Overloading & Overriding)',
                'Abstraction: Abstract Classes & Interfaces'
            ] },
            { title: 'Arrays & Strings', topics: [
                '1D & 2D Arrays: Declaration, Initialization, Traversal',
                'Array Operations, Enhanced for loop',
                'Strings: String, StringBuilder, StringBuffer',
                'Common String Methods and Immutability'
            ] },
            { title: 'Exception Handling', topics: [
                'Types: Checked & Unchecked Exceptions',
                'try-catch, finally, throw, throws',
                'Custom Exception Classes'
            ] },
            { title: 'Collections Framework', topics: [
                'Interfaces: List, Set, Map',
                'Implementations: ArrayList, LinkedList, HashSet, HashMap, TreeMap',
                'Iterators & Enhanced for loop',
                'Generics & Comparable/Comparator'
            ] },
            { title: 'Java 8+ Features (Modern Java)', topics: [
                'Lambda Expressions',
                'Functional Interfaces (Predicate, Function, etc.)',
                'Stream API: map, filter, reduce, collect',
                'Method References'
            ] },
            { title: 'File Handling & I/O', topics: [
                'Reading/Writing Files (FileReader, FileWriter, BufferedReader, etc.)',
                'Serialization & Deserialization',
                'Java NIO (Intro only)'
            ] },
            { title: 'Java Database Connectivity (JDBC)', topics: [
                'JDBC Drivers & Architecture',
                'Connecting Java with MySQL',
                'Executing Queries (Statement & PreparedStatement)',
                'ResultSet Handling',
                'Transactions & Exception Management'
            ] },
            { title: 'Web Development in Java', topics: [
                'Servlets: Lifecycle, doGet()/doPost()',
                'Form Handling, Session Tracking',
                'JavaServer Pages (JSP): Scriptlets, Directives, JSTL',
                'Expression Language (EL)',
                'MVC Architecture: Servlet as Controller, JSP as View'
            ] },
            { title: 'Projects & Assignments', topics: [
                'Mini Projects on Core Concepts',
                'File I/O & Exception-Based Assignment',
                'JDBC-based CRUD App',
                'Final Full-stack Mini Project using Java + JDBC + JSP + Servlets'
            ] }
        ],
        toolsCovered: [
            'Java (JDK 8/11/17)',
            'VS Code',
            'Eclipse',
            'IntelliJ',
            'MySQL',
            'Apache Tomcat'
        ],
        certification: 'Certification on Completion',
        placement: 'Placement Assistance & Placed Students Showcase',
        showcase: 'Hiring Company Logos & Placed Students Gallery'
    },
    {
        id: 'oc4',
        slug: 'dsa-using-cpp-offline',
        title: 'Data Structures & Algorithms with C++',
        category: 'offline',
        level: 'Beginner to Advanced',
        duration: '2 Months',
        location: 'indore',
        lectures: '25+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '5000',
        originalPrice: '5000',
        banner: {
            title: 'DSA with C++',
            subtitle: 'Data Structures & Algorithms',
            background: 'bg-gradient-to-r from-purple-600 to-indigo-600',
            Icon: Network
        },
        description: 'Data Structures and Algorithms (DSA) are fundamental concepts essential for efficient programming and problem-solving. This course provides a thorough introduction to DSA using C++, designed for beginners who want to gain a solid understanding of these critical concepts. By learning DSA, students will enhance their programming skills, improve code performance, and prepare for technical interviews. This course covers a wide array of topics from the basics to advanced data structures and algorithms.',
        overview: 'Data Structures and Algorithms (DSA) are fundamental concepts essential for efficient programming and problem-solving. This course provides a thorough introduction to DSA using C++, designed for beginners who want to gain a solid understanding of these critical concepts. By learning DSA, students will enhance their programming skills, improve code performance, and prepare for technical interviews. This course covers a wide array of topics from the basics to advanced data structures and algorithms.',
        highlights: [
            'Premium Coding Course',
            'Experienced Trainer',
            'Instructor Led/Self-Paced Course',
            'Real-time Assignments',
            'Assessment/Online Test',
            'Certification',
            'Placement Assistance'
        ],
        whyOSOP: [
            'India’s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        skillsCovered: 'C++, Data Structures, Algorithms, Problem-Solving',
        toolsCovered: 'C++ Compiler, Visual Studio',
        certification: 'Training Certification on Successful Completion of the Course',
        curriculum: [
            { title: 'INTRODUCTION TO DSA', topics: ['Overview and Types of Data Structures'] },
            { title: 'PREREQUISITES FOR DSA', topics: ['Functions', 'Arrays', 'Classes & Objects', 'Pointers', 'Object Patterning'] },
            { title: 'ADDRESS CALCULATION', topics: ['Address Calculation of 1-D, 2-D, and 3-D Arrays'] },
            { title: 'TIME & SPACE COMPLEXITY', topics: ['Best Case (Ω)', 'Average Case (Θ)', 'Worst Case (O)'] },
            { title: 'STACKS', topics: ['Definition, Operations, Applications', 'Static (Array) and Dynamic (Linked List) Implementation'] },
            { title: 'QUEUES', topics: ['Definition, Operations, Applications', 'Static (Array) and Dynamic (Linked List) Implementation'] },
            { title: 'LINKED LISTS', topics: ['Singly, Doubly, and Circular Linked Lists', 'Definition and Applications'] },
            { title: 'RECURSION & BACKTRACKING', topics: ['Concept and Basic Problems with Implementation'] },
            { title: 'SORTING', topics: ["Let's Play with Code", 'Incremental Approach: Bubble Sort, Selection Sort, Insertion Sort, Radix Sort', 'Divide & Conquer Approach: Merge Sort, Quick Sort, Heap Sort'] },
            { title: 'SEARCHING', topics: ['Linear Search and Binary Search'] },
            { title: 'DYNAMIC PROGRAMMING', topics: ['Optimization on Recursion', 'Tabulation and Memorization', 'Solutions to Common Problems'] },
            { title: 'TREES', topics: ['Binary Trees and Binary Search Trees', 'Definition, Creation, Implementation, and Traversals', 'AVL Trees'] },
            { title: 'GRAPHS', topics: ['Definition, Operations, Applications', "Graph Algorithms (Dijkstra's, Bellman-Ford)"] },
            { title: 'HASHING TECHNIQUES', topics: ['Concept and Collision Handling Techniques', 'How to Select Hashing Functions'] },
            { title: 'GREEDY ALGORITHMS', topics: ['Need & Concepts', 'Solutions to Common Problems'] }
        ]
    },
    {
        id: 'oc5',
        slug: 'python-for-beginner-offline',
        title: 'Python Programming for Beginners',
        category: 'offline',
        level: 'Beginner',
        duration: '2 Months',
       location: 'indore',
        lectures: '25+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '7000',
        originalPrice: '7000',
        banner: {
            title: 'Python',
            subtitle: 'Programming for Beginners',
            background: 'bg-gradient-to-r from-green-400 to-blue-400',
            Icon: Brain
        },
        description: 'Offline Python programming course for absolute beginners.',
        overview: 'Start your Python journey with this beginner-friendly classroom course.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Support', description: '24/7 doubt resolution' }
        ],
        curriculum: [
            { title: 'Overview of Python', topics: [
                'History, Features & Uses of Python',
                'Installation, IDE Setup (IDLE, VS Code, PyCharm)',
                'Working with Python Shell & Files',
                'Basic Syntax, Comments, Indentation, Input/Output',
                'Variables, Data Types & Type Casting'
            ] },
            { title: 'Operators, Decision Making & Looping', topics: [
                'Operators: Arithmetic, Relational, Logical, Assignment, Membership, Identity',
                'Conditional Statements: if, if-else, elif, Nested if',
                'Looping: while, for, nested, range()',
                'Loop Control: break, continue, pass',
                'Type Conversion & Operator Precedence'
            ] },
            { title: 'Functions and Modules', topics: [
                'Defining Functions, Arguments, Return Values',
                'f-Strings & String Formatting Operations',
                'Lambda (Anonymous) Functions',
                'Scope: Global & Local Variables',
                'Built-in Modules (Math, Time, Random)',
                'Creating & Importing Custom Modules',
                'Python Packages and Init File (__init__.py)'
            ] },
            { title: 'Data Structures in Python', topics: [
                'Strings: Accessing, Slicing, String Methods',
                'Lists: Indexing, Slicing, Functions & Methods',
                'Tuples: Creation, Access, Immutability',
                'Sets: Operations, Unique Element Filtering',
                'Dictionaries: Key-Value Pairs, Access, Methods',
                'Collections Module: deque, Counter, defaultdict, OrderedDict, namedtuple'
            ] },
            { title: 'File Handling & Exception Handling', topics: [
                'File Operations: Open, Read, Write, Append, Close',
                'Reading from Keyboard',
                'File Modes: r, w, a, x, b, t',
                'Exception Types, Try-Except, Else, Finally',
                'Custom Exceptions, Assertion Handling'
            ] },
            { title: 'Object-Oriented Programming (OOP)', topics: [
                'Classes & Objects',
                '__init__() Constructor, self Keyword',
                'Encapsulation, Inheritance, Polymorphism',
                'Overriding, Abstraction',
                'Decorators & Descriptors',
                'Class vs Instance Variables'
            ] },
            { title: 'Database Programming with MySQL', topics: [
                'Introduction to Databases',
                'Installing MySQL & Using GUI/CUI',
                'SQL Basics: DDL, DML, CRUD Operations',
                'Python Database Connectivity using PyMySQL / MySQLdb',
                'Executing Queries, Fetching Data'
            ] }
            
        ]
    },
    {
        id: 'oc6',
        slug: 'python-for-developer-offline',
        title: 'Advanced Python Development',
        category: 'offline',
        level: 'Intermediate to Advanced',
        duration: '4 Months',
        location: 'indore',
        lectures: '80+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '12500',
        originalPrice: '15000',
        banner: {
            title: 'Advanced Python',
            subtitle: 'Development',
            background: 'bg-gradient-to-r from-green-600 to-blue-600',
            Icon: Code
        },
        description: 'Offline advanced Python development course.',
        overview: 'Master Python for professional development through classroom-based training.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Professional applications' }
        ],
        curriculum: [
            { title: 'Advanced Python', topics: ['Decorators', 'Generators', 'Context Managers'] },
            { title: 'Web Frameworks', topics: ['Flask', 'Django', 'FastAPI'] },
            { title: 'Production', topics: ['Testing', 'Deployment', 'Performance'] }
        ]
    },
    {
        id: 'oc7',
        slug: 'mysql-offline',
        title: 'MySQL Database Management',
        category: 'offline',
        level: 'Beginner to Advanced',
        duration: '1 Month',
        location: 'Noida, Sector 62',
        lectures: '15+',
        price: '3000',
        originalPrice: '3000',
        banner: {
            title: 'MySQL',
            subtitle: 'Database Management',
            background: 'bg-gradient-to-r from-blue-700 to-indigo-800',
            Icon: Database
        },
        description: 'Offline MySQL database management course.',
        overview: 'Learn MySQL database design and administration through classroom training.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Database projects' }
        ],
        curriculum: [
            { title: 'SQL Basics', topics: ['SELECT', 'INSERT', 'UPDATE', 'DELETE'] },
            { title: 'Advanced SQL', topics: ['JOINS', 'Subqueries', 'Indexes'] },
            { title: 'Administration', topics: ['Performance Tuning', 'Backup', 'Security'] }
        ]
    },
    {
        id: 'oc8',
        slug: 'c-cpp-dsa-combo-offline',
        title: 'C, C++ & DSA Complete Course',
        category: 'offline',
        level: 'Beginner to Advanced',
        duration: '4.5 Months',
       location: 'indore',
        lectures: '50+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '11000',
        originalPrice: '11000',
        banner: {
            title: 'C, C++ & DSA',
            subtitle: 'Complete Course',
            background: 'bg-gradient-to-r from-green-600 to-blue-600',
            Icon: Layers
        },
        description: 'Comprehensive combo course covering C Programming, C++ with OOP, and DSA using C++. Ideal for beginners and those preparing for placements.',
        overview: 'This OSOP Combo Course covers Core C Programming, C++ with OOP Concepts, and Data Structures & Algorithms (DSA) using C++. It is designed to build a strong programming foundation and prepare students for real-world coding and technical interviews.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            'India’s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        skillsCovered: 'C, C++, OOP, DSA, Problem-Solving',
        toolsCovered: 'Turbo C++, GCC, VS Code, Online Compilers',
        certification: 'Training Certification on Successful Completion of the Course',
        curriculum: [
            { title: 'Core C Programming (Foundation)', topics: [
                'Introduction to Programming & C Language: History, uses, compiler setup, structure of a C program',
                'Variables, Data Types & Operators: Constants, type casting, ASCII, bitwise operators',
                'Control Structures: if/else, switch, loops (for, while, do-while), nested loops',
                'Functions & Recursion: Function declaration, definition, recursion basics',
                'Pointers & Memory: Basics, pointer arithmetic, dynamic memory allocation',
                'Arrays & Strings: 1D/2D/3D arrays, string functions, matrix operations',
                'User-defined Data Types: Structures, unions, typedef, enums',
                'File Handling: File operations, modes, file pointers'
            ] },
            { title: 'C++ Programming with OOP Concepts', topics: [
                'C++ Basics: cout/cin, namespaces, reference variables, std::string class',
                'Object-Oriented Programming: Classes & Objects, Encapsulation, Abstraction',
                'Inheritance (Single, Multiple, Multilevel), Polymorphism',
                'Constructor, Destructor, Static Members',
                'Advanced OOP Features: Operator Overloading, Function Overloading & Overriding',
                'Friend Class/Function, Virtual Functions, Abstract Classes',
                'this Pointer, Scope Resolution Operator',
                'Templates & Exception Handling: Function & class templates, basic try-catch blocks',
                'File Handling in C++: File streams, binary files, operator overloading for I/O'
            ] },
            { title: 'Data Structures & Algorithms (DSA using C++)', topics: [
                'Foundations: Time & Space Complexity, Function Basics, Pointers Recap',
                'Linear Data Structures: Arrays (1D/2D/3D), Stacks, Queues, Linked Lists (Singly, Doubly, Circular)',
                'Recursion & Backtracking: Implementation patterns, common problems',
                'Searching & Sorting Algorithms: Linear/Binary Search, Bubble, Insertion, Selection, Merge, Quick, Heap, Radix Sort',
                'Advanced Data Structures: Trees (Binary Tree, BST, AVL), Graphs, Hash Tables',
                'Algorithmic Techniques: Greedy Algorithms, Dynamic Programming (Tabulation & Memoization)',
                'Graph Algorithms: Dijkstra’s, Bellman-Ford'
            ] }
        ]
    },
    {
        id: 'oc9',
        slug: 'c-programming-offline',
        title: 'C for Beginners',
        category: 'offline',
        level: 'Beginner',
        duration: '2 Months',
        location: 'indore',
        lectures: '25+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '4500',
        originalPrice: '4500',
        banner: {
            title: 'C Programming',
            subtitle: 'For Beginners',
            background: 'bg-gradient-to-r from-blue-800 to-blue-600',
            Icon: Code
        },
        description: 'C programming is a foundational language for understanding core programming concepts. It is widely used for system programming, embedded systems, and other low-level applications. C provides a strong base to build programming skills, and mastering C helps in understanding the internal architecture of computer systems. This course introduces the basic concepts of C programming, starting from the very fundamentals to more intermediate topics. It is designed for people with no prior programming experience.',
        overview: 'C programming is a foundational language for understanding core programming concepts. It is widely used for system programming, embedded systems, and other low-level applications. C provides a strong base to build programming skills, and mastering C helps in understanding the internal architecture of computer systems. This course introduces the basic concepts of C programming, starting from the very fundamentals to more intermediate topics. It is designed for people with no prior programming experience.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            'India’s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        skillsCovered: 'C Programming',
        toolsCovered: 'Turbo C++, Vs Code, GCC Compiler',
        certification: 'Training Certification on Successfully Completion of the Course.',
        curriculum: [
            { title: 'Introduction to Computer & C Programming', topics: [
                'Introduction to Computer',
                'Definition and functions of an Operating System',
                'Brief History and Uses of C Programming'
            ] },
            { title: 'C Basics', topics: [
                'Variable & Constant',
                'Introduction to Data Types',
                'Introduction to ASCII',
                'Introduction to Operators and Types',
                'Type Casting in C Programming',
                'Algorithm and Flowchart'
            ] },
            { title: 'C Programming Structure', topics: [
                'Basic C Programs',
                'Types of Errors in C Programming'
            ] },
            { title: 'Conditional Statements', topics: [
                'Conditional Statement (if..else)',
                'Relational (Comparison) Operators',
                'Basic C if..else Programs',
                'Logical Operators in C Programming',
                'Conditional Operator in C Programming',
                'Ladder if...else'
            ] },
            { title: 'Operators in C', topics: [
                'Increment / Decrement Operators',
                'Introduction to Number Systems',
                'Definition and Purpose of Bitwise Operators in C',
                'C Assignment Operators',
                'C Operator Precedence'
            ] },
            { title: 'Looping Statements', topics: [
                'Introduction to Loops & Types',
                'while Loop',
                'do while Loop',
                'for Loop',
                'Nested Loops'
            ] },
            { title: 'Jump Statements in C Programming', topics: [
                'Break Statement',
                'Continue Statement',
                'Goto Statement'
            ] },
            { title: 'Switch Statement', topics: [
                'Introduction to switch Statement'
            ] },
            { title: 'Functions in C Programming', topics: [
                'Introduction to Functions in C Programming',
                'Storage Classes in C Programming',
                'Preprocessor Directives'
            ] },
            { title: 'Pointers in C', topics: [
                'Introduction to Pointers',
                'Types of Pointers',
                'Pointer to Array',
                'Dynamic Memory Management'
            ] },
            { title: 'Recursion', topics: [
                'Introduction to Recursion'
            ] },
            { title: 'Arrays in C', topics: [
                'Introduction to Array & Its Types',
                'Pointer to Array',
                'Introduction to String',
                'Useful String Functions',
                'Example Code for String Operations'
            ] },
            { title: '2D Arrays', topics: [
                'Introduction to 2D Arrays',
                'Example Code for Creating and Adding Elements in a 2D Array',
                'Example Code for Transposing a Matrix Using 2D Array'
            ] },
            { title: 'User-Defined Data Types', topics: [
                'Introduction to User-Defined Data Types',
                'Structure',
                'Union',
                'Typedef',
                'Enum'
            ] },
            { title: 'File Handling', topics: [
                'File Handling Operations',
                'File Handling Functions',
                'Modes of File Opening',
                'Example Codes',
                'File Pointer Movement Functions'
            ] }
        ]
    },
    {
        id: 'oc10',
        slug: 'cpp-oops-offline',
        title: 'OOPs in C++',
        category: 'offline',
        level: 'Intermediate',
        duration: '45 Days',
        location: 'indore',
        lectures: '20+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '3000',
        originalPrice: '3000',
        banner: {
            title: 'C++ OOP',
            subtitle: 'Object-Oriented Programming',
            background: 'bg-gradient-to-r from-purple-700 to-blue-700',
            Icon: Code
        },
        description: 'C++ is a powerful programming language that combines the efficiency of C with the flexibility of Object-Oriented Programming (OOP). This course covers the fundamental concepts of C++ and OOP principles, providing a solid foundation for building robust and scalable applications. Whether you are a beginner or looking to enhance your programming skills, this course will guide you through essential topics and hands-on projects.',
        overview: 'C++ is a powerful programming language that combines the efficiency of C with the flexibility of Object-Oriented Programming (OOP). This course covers the fundamental concepts of C++ and OOP principles, providing a solid foundation for building robust and scalable applications. Whether you are a beginner or looking to enhance your programming skills, this course will guide you through essential topics and hands-on projects.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            'India’s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        skillsCovered: 'C++ Programming with OOP principles',
        toolsCovered: 'Turbo C++, Visual Studio Code, GCC Compiler',
        certification: 'Training Certification on Successful Completion of the Course.',
        curriculum: [
            { title: 'Introduction to C++', topics: ['Overview of C++ and its uses'] },
            { title: 'Basic Input/Output', topics: ['Using cout, cin, and endl'] },
            { title: 'Namespaces in C++', topics: ['Understanding namespaces and their importance'] },
            { title: 'Reference Variables', topics: ['Introduction to reference variables'] },
            { title: 'Function Overloading', topics: ['Concept and examples of function overloading'] },
            { title: 'std::string Class in C++', topics: [
                'String operations including size, length, empty, substr, find, replace, and compare',
                'Concatenation and appending strings'
            ] },
            { title: 'Object-Oriented Programming (OOP)', topics: [
                'Introduction to OOP and its features',
                'Differences between object-oriented and procedural programming',
                'Features of OOP: Class, Object, Encapsulation, Abstraction, Inheritance, Polymorphism'
            ] },
            { title: 'Access Modifiers', topics: ['Understanding public, private, and protected access modifiers'] },
            { title: 'this Pointer in C++', topics: ['Usage and importance of this pointer'] },
            { title: 'Scope Resolution Operator', topics: [
                'Examples using scope resolution operator with global and local variables',
                'Examples with class members'
            ] },
            { title: 'Object Passing and Returning', topics: [
                'Concept of object passing and returning',
                'Example program demonstrating object passing and returning'
            ] },
            { title: 'Constructors and Destructors', topics: [
                'Introduction to constructors and their types',
                'Understanding destructors'
            ] },
            { title: 'Inline Functions', topics: ['Definition and usage of inline functions'] },
            { title: 'Static Members and Functions', topics: [
                'Concept of static members and static functions',
                'Object counting example'
            ] },
            { title: 'Dynamic Memory Management', topics: ['Difference between dynamic object and dynamic constructor'] },
            { title: 'Friend Function and Friend Class', topics: ['Introduction to friend functions and classes'] },
            { title: 'Operator Overloading', topics: ['Concept and implementation of operator overloading'] },
            { title: 'Default Arguments', topics: ['Using default arguments in functions'] },
            { title: 'Inheritance and its Types', topics: ['Types of inheritance and their applications'] },
            { title: 'Function Overriding and Virtual Functions', topics: ['Understanding function overriding and virtual functions'] },
            { title: 'Abstract Classes', topics: ['Introduction to abstract classes and their significance'] },
            { title: 'Generalization and Specialization', topics: ['Concepts of generalization and specialization in OOP'] },
            { title: 'IS-A and HAS-A Relationship', topics: ['Understanding the relationships in OOP'] },
            { title: 'Exception Handling', topics: ['Introduction to exception handling mechanisms'] },
            { title: 'Templates in C++', topics: ['Function templates and class templates'] },
            { title: 'C++ IO Stream', topics: [
                'Introduction to C++ I/O stream and functions',
                'I/O formatting functions and manipulators',
                'User-defined manipulators'
            ] },
            { title: 'File Handling in C++', topics: [
                'Introduction to file handling and file I/O',
                'File stream classes and operations',
                'Examples of file operations',
                'Binary mode operations'
            ] },
            { title: 'Overloading Insertion and Extraction Operators', topics: ['Understanding operator overloading for I/O operations'] }
        ]
    },
    {
        id: 'oc11',
        slug: 'python-data-analytics-offline',
        title: 'Python Programming & Data Analytics',
        category: 'offline',
        level: 'Beginner to Advanced',
        duration: '4 Months',
       location: 'indore',
        lectures: '80+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '12500',
        originalPrice: '15000',
        banner: {
            title: 'Python & Data',
            subtitle: 'Analytics',
            background: 'bg-gradient-to-r from-green-500 to-blue-600',
            Icon: Brain
        },
        description: 'Offline Python programming with data analytics training.',
        overview: 'Learn Python programming and data analysis through classroom-based training.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Data analysis projects' }
        ],
        curriculum: [
            { title: 'Python Basics', topics: ['Syntax', 'Data Structures', 'Functions'] },
            { title: 'Data Analysis', topics: ['Pandas', 'NumPy', 'Matplotlib'] },
            { title: 'Advanced Topics', topics: ['Machine Learning', 'Statistics', 'Visualization'] }
        ]
    },
    {
        id: 'oc12',
        slug: 'sql-for-beginners-offline',
        title: 'SQL for Beginners',
        category: 'offline',
        level: 'Beginner',
        duration: '1 Month',
       location: 'indore',
        lectures: '15+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        price: '3000',
        originalPrice: '3000',
        banner: {
            title: 'SQL',
            subtitle: 'For Beginners',
            background: 'bg-gradient-to-r from-blue-500 to-indigo-600',
            Icon: Database
        },
        description: 'SQL (Structured Query Language) is the standard language for managing and manipulating relational databases. It is widely used for data retrieval, data insertion, updating, and database schema creation and modification. Understanding SQL is crucial for anyone interested in data management, data analysis, and backend development. This course covers fundamental concepts to advanced SQL functionalities, making it suitable for learners with no prior database experience.',
        overview: 'SQL (Structured Query Language) is the standard language for managing and manipulating relational databases. It is widely used for data retrieval, data insertion, updating, and database schema creation and modification. Understanding SQL is crucial for anyone interested in data management, data analysis, and backend development. This course covers fundamental concepts to advanced SQL functionalities, making it suitable for learners with no prior database experience.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            'India’s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        skillsCovered: 'SQL Programming',
        toolsCovered: 'MySQL Workbench, Command Line Interface (CLI)',
        certification: 'Training Certification on Successful Completion of the Course',
        curriculum: [
            { title: 'Introduction to Database', topics: ['Definition of Database', 'Drawbacks of File System'] },
            { title: 'Database Management System (DBMS)', topics: ['What is DBMS?', 'Types of DBMS'] },
            { title: 'MySQL Overview', topics: ['Introduction to MySQL', 'History of MySQL'] },
            { title: 'Introduction to SQL', topics: ['What is SQL?', 'What Can SQL Do?', 'SQL Commands'] },
            { title: 'SQL Data Types', topics: ['Introduction to SQL Data Types'] },
            { title: 'SQL Commands', topics: ['SQL Create Statement', 'Insert Statement'] },
            { title: 'Data Retrieval', topics: ['Select Command', 'Where Clause', 'SQL Syntax Overview'] },
            { title: 'SQL Operators', topics: ['Basic SQL Operators', 'Logical Operators', 'ORDER BY Clause', 'BETWEEN Clause', 'LIKE Operator and Wildcards'] },
            { title: 'Data Manipulation', topics: ['Delete Command', 'Update Command'] },
            { title: 'Constraints in SQL', topics: ['Primary Key, Unique Key, NOT NULL', 'Foreign Key', 'ALTER TABLE Operations'] },
            { title: 'Date and Time', topics: ['Data/Time Data Types', 'Date and Time Functions'] },
            { title: 'Regular Expressions', topics: ['Introduction to REGEXP', 'REGEXP Examples'] },
            { title: 'Additional Constraints', topics: ['CHECK Constraint', 'DEFAULT Constraint'] },
            { title: 'Aggregate Functions', topics: ['Using Aggregate Functions: SUM(), MIN(), AVG(), etc.'] },
            { title: 'Nested Queries', topics: ['Subquery within Another Query'] },
            { title: 'Joins in SQL', topics: ['Inner Join', 'Left Outer Join', 'Right Outer Join', 'Full Outer Join', 'Self Join'] },
            { title: 'Grouping Data', topics: ['Group By Statement', 'Example Queries of Group Statement', 'HAVING Clause'] },
            { title: 'Indexing', topics: ['Creating and Dropping Index'] },
            { title: 'Views in SQL', topics: ['Creating and Dropping Views'] },
            { title: 'User Privileges', topics: ['GRANT', 'REVOKE'] }
        ]
    },
    {
        id: 'oc13',
        slug: 'devops-engineering-offline',
        title: 'DevOps Engineering',
        category: 'offline',
        level: 'Intermediate to Advanced',
        duration: '5 Months',
        location: 'indore',
        price: '15000',
        originalPrice: '44999',
        lectures: '150+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: 'DevOps Engineering',
            subtitle: 'CI/CD, Cloud & Automation',
            background: 'bg-gradient-to-r from-blue-600 to-purple-600',
            Icon: Cloud
        },
        description: 'Master DevOps practices, tools, and methodologies through hands-on classroom training. Learn CI/CD, containerization, cloud platforms, and infrastructure automation.',
        overview: 'This comprehensive DevOps course covers everything from version control to cloud deployment, preparing you for modern software development practices.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'DevOps automation projects' }
        ],
        curriculum: [
            { title: 'DevOps Fundamentals', topics: ['Introduction to DevOps', 'DevOps Culture and Practices', 'Version Control with Git', 'Git Workflows'] },
            { title: 'Linux & Shell Scripting', topics: ['Linux Fundamentals', 'Shell Scripting (Bash)', 'System Administration', 'Process Management'] },
            { title: 'Containerization', topics: ['Docker Fundamentals', 'Docker Images and Containers', 'Docker Compose', 'Container Orchestration'] },
            { title: 'CI/CD Pipelines', topics: ['Jenkins Automation', 'GitHub Actions', 'GitLab CI/CD', 'Pipeline as Code'] },
            { title: 'Cloud Platforms', topics: ['AWS Fundamentals', 'Azure Basics', 'Google Cloud Platform', 'Infrastructure as Code'] },
            { title: 'Monitoring & Logging', topics: ['Prometheus & Grafana', 'ELK Stack', 'Application Monitoring', 'Alerting Systems'] }
        ]
    },
    {
        id: 'oc14',
        slug: 'ai-ml-specialization-offline',
        title: 'AI & Machine Learning Specialization',
        category: 'offline',
        level: 'Intermediate to Advanced',
        duration: '6 Months',
        location: 'Indore',
        price: '15000',
        originalPrice: '21000',
        lectures: '180+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: 'AI & ML Specialization',
            subtitle: 'Deep Learning & Neural Networks',
            background: 'bg-gradient-to-r from-purple-600 to-pink-600',
            Icon: Brain
        },
        description: 'Comprehensive AI and Machine Learning course covering algorithms, deep learning, neural networks, and real-world applications.',
        overview: 'Master the fundamentals of AI/ML, build neural networks, and deploy machine learning models for real-world applications.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'AI/ML model development' }
        ],
        curriculum: [
            { title: 'Machine Learning Fundamentals', topics: ['Supervised vs Unsupervised Learning', 'Linear & Logistic Regression', 'Decision Trees & Random Forests', 'Support Vector Machines'] },
            { title: 'Deep Learning', topics: ['Neural Network Architecture', 'Backpropagation Algorithm', 'Convolutional Neural Networks (CNN)', 'Recurrent Neural Networks (RNN)'] },
            { title: 'Natural Language Processing', topics: ['Text Preprocessing', 'Word Embeddings', 'Transformer Models', 'BERT & GPT Models'] },
            { title: 'Computer Vision', topics: ['Image Processing', 'Object Detection', 'Image Segmentation', 'Face Recognition'] },
            { title: 'Model Deployment', topics: ['Model Serialization', 'API Development', 'Cloud Deployment', 'Model Monitoring'] }
        ]
    },
    {
        id: 'oc15',
        slug: 'software-testing-offline',
        title: 'Software Testing & Quality Assurance',
        category: 'offline',
        level: 'Beginner to Advanced',
        duration: '4 Months',
        location: 'indore',
        price: '15000',
        originalPrice: '21000',
        lectures: '120+',
        mode: 'Offline Classroom',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: '60+',
        banner: {
            title: 'Software Testing',
            subtitle: 'Quality Assurance & Automation',
            background: 'bg-gradient-to-r from-green-600 to-teal-600',
            Icon: Bug
        },
        description: 'Comprehensive software testing course covering manual testing, automation, performance testing, and quality assurance methodologies.',
        overview: 'Learn testing fundamentals, automation frameworks, and best practices for ensuring software quality in real-world projects.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whatYouGet: [
            { title: 'Offline Learning', description: 'Face-to-face classroom interaction' },
            { title: 'Certification', description: 'Industry-recognized certificate' },
            { title: 'Projects', description: 'Testing automation projects' }
        ],
        curriculum: [
            { title: 'Testing Fundamentals', topics: ['Software Testing Life Cycle (STLC)', 'Testing Types & Levels', 'Test Case Design Techniques', 'Bug Reporting & Tracking'] },
            { title: 'Manual Testing', topics: ['Functional Testing', 'Non-Functional Testing', 'Usability Testing', 'Compatibility Testing'] },
            { title: 'Automation Testing', topics: ['Selenium WebDriver', 'TestNG Framework', 'Page Object Model', 'Data-Driven Testing'] },
            { title: 'Performance Testing', topics: ['JMeter Fundamentals', 'Load Testing', 'Stress Testing', 'Performance Monitoring'] },
            { title: 'API Testing', topics: ['REST API Testing', 'Postman Tool', 'API Automation', 'JSON & XML Handling'] },
            { title: 'Mobile Testing', topics: ['Mobile App Testing', 'Appium Framework', 'Device Testing', 'Cross-Platform Testing'] }
        ]
    }
]; 